import FlexPane from './_flex-pane.js'
import MenuLinkPromotions from './_menu-link-promotions.js'
import LinkMenu from './_link-menu.js'

export default {
  name: 'PageContextMenu',
  values: {
    priceBoostLink: {
      isIconVisible: true,
      iconName: 'lightning',
      iconBackground: {
        configSet: FlexPane,
        configValues: {
          style: {
            flexGrow: 0,
          },
        },
      },
    },
    baseLink: {
      iconContainer: {
        configSet: FlexPane,
        configValues: {
          style: {
            padding: 0,
            flexGrow: 0,
            minWidth: '24px',
          },
        },
      },
      iconBackground: {
        configSet: FlexPane,
        configValues: {
          style: {
            flexGrow: 0,
          },
        },
      },
      icon: {
        style: {
          minHeight: '16px',
          maxHeight: '16px',
          minWidth: '16px',
          maxWidth: '16px',
        },
      },
    },
    useRowLayout: false,
    rowLinkMenu: {
      configSet: MenuLinkPromotions,
      configValues: {
        menuRow: {
          _mobile_showItemIcon: true,
          _desktop_showItemIcon: false,
          itemIcon: {
            style: {
              width: 16,
              height: 16,
              minWidth: 16,
            },
          },
          style: {
            container: {
              padding: '0px',
            },
          },
          itemLabel: {
            truncate: true,
          },
          itemInnerContainer: {
            style: {
              width: 'auto',
              flexDirection: 'row',
              padding: '0 4px',
            },
          },
          buttonScrollPane: {
            contentContainer: {
              itemSpacing: '8px',
            },
          },
          chevronIcon: {
            src: 'chevron-right',
          },
        },
      },
    },
    tileLinkMenu: {
      configSet: LinkMenu,
      configValues: {
        _mobile_showCompactLayout: true,
        _mobile_showExtraItemDetails: true,
        _mobile_showHeader: false,
        compactContainer: {
          style: {
            flexDirection: 'row',
          },
        },
        icon: {
          style: {
            minWidth: '36px',
            padding: '0 0 0 20px',
          },
        },
        regularItem: {
          unselected: {
            style: {
              base: {
                padding: '12px 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                padding: '12px 8px',
              },
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
